// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      {/* Header */}
      <header className="header">
        <div className="logo">Pode Marcar</div>
        <nav className="nav">
          <a href="#funcionalidades">Funcionalidades</a>
          <a href="#planos">Planos</a>
          <a href="#contato">Contato</a>
        </nav>
        <button className="btn-primary">Acessar Sistema</button>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>O Sistema de Agendamento Inteligente que Você Merece.</h1>
          <p>
            Simplifique a gestão do seu negócio, reduza faltas e aumente sua produtividade com a nossa plataforma completa.
          </p>
          <div className="hero-actions">
            <button className="btn-primary btn-large">Comece Agora Grátis</button>
            <button className="btn-secondary btn-large">Ver Demonstração</button>
          </div>
        </div>
        <div className="hero-image">
          <div className="mockup-placeholder">Mockup do Sistema Aqui</div>
        </div>
      </section>

      {/* Features Section */}
      <section id="funcionalidades" className="features-section">
        <h2>Funcionalidades que Transformam</h2>
        <p className="section-subtitle">Tudo o que você precisa para gerenciar seu negócio em um só lugar.</p>
        <div className="features-grid">
          <div className="feature-card">
            <div className="icon-placeholder">📅</div>
            <h3>Agendamento Online</h3>
            <p>Seus clientes agendam 24h por dia, 7 dias por semana, sem depender de você.</p>
          </div>
          <div className="feature-card">
            <div className="icon-placeholder">💬</div>
            <h3>Lembretes Automáticos</h3>
            <p>Reduza o 'no-show' com lembretes automáticos via WhatsApp.</p>
          </div>
          <div className="feature-card">
            <div className="icon-placeholder">📊</div>
            <h3>Gestão Financeira</h3>
            <p>Controle de caixa, comissões e relatórios para uma visão clara do seu lucro.</p>
          </div>
        </div>
      </section>

      {/* Plans Section */}
      <section id="planos" className="plans-section">
        <h2>Escolha seu Plano</h2>
        <p className="section-subtitle">Planos flexíveis para atender a necessidade do seu negócio.</p>
        <div className="plans-grid">
          {/* Mensal */}
          <div className="plan-card">
            <h3>Mensal</h3>
            <p className="plan-price">R$49/mês</p>
            <ul>
              <li>Agendamento Online</li>
              <li>Lembretes Automáticos</li>
            </ul>
            <button className="btn-primary btn-large">Assinar Mensal</button>
          </div>

          {/* Trimestral */}
          <div className="plan-card plan-featured">
            <h3>Trimestral</h3>
            <p className="plan-price">R$135/3 meses <span className="plan-save">Economize 10%</span></p>
            <ul>
              <li>Agendamento Online</li>
              <li>Lembretes Automáticos</li>
              <li>Relatórios</li>
            </ul>
            <button className="btn-primary btn-large">Assinar Trimestral</button>
          </div>

          {/* Anual */}
          <div className="plan-card">
            <h3>Anual</h3>
            <p className="plan-price">R$480/ano <span className="plan-save">Economize 20%</span></p>
            <ul>
              <li>Agendamento Online</li>
              <li>Lembretes Automáticos</li>
              <li>Relatórios</li>
              <li>Suporte Premium</li>
            </ul>
            <button className="btn-primary btn-large">Assinar Anual</button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">Pode Marcar</div>
          <div className="footer-links">
            <h4>Empresa</h4>
            <a href="#sobre">Sobre Nós</a>
            <a href="#carreiras">Carreiras</a>
            <a href="#termos">Termos de Uso</a>
          </div>
          <div className="footer-links">
            <h4>Suporte</h4>
            <a href="#ajuda">Central de Ajuda</a>
            <a href="#contato">Fale Conosco</a>
          </div>
          <div className="footer-contact">
            <h4>Contato</h4>
            <p>(19) 99115-6940</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Pode Marcar. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
